import React, { useEffect, useState } from 'react';
import "./priceList.css";
import api from '../../axiosInstance';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Box, Gridv2, Typography, Modal } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
// import { Button, TextField,  } from "@mui/material";
// import {  Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import TableHead from '@mui/material/TableHead';
import Swal from "sweetalert2";
import modalbg from "../../Assets/bg.jpg"
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import priceListdata from './priceListdata.json'
const theme = createTheme({
  typography: {
    fontFamily: "Calibri, sans-serif",
  },
});


function PriceList() {
  const { did, cid } = useParams(); // Extract ID from URL


  const rowdata =  priceListdata?.myprice?.map((item)=>item)



  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "price", headerName: "Buying Price", width: 150 },
    { field: "name", headerName: "Name", width: 200 },
    // {
    //   field: "selling_price",
    //   headerName: "Selling Price",
    //   width: 180,
    //   renderCell: (params) => (
    //     <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>

    //       <TextField
    //         value={params.row.selling_price}
    //         // onChange={(e) =>
    //         //   handleChange(params.row.id, "selling_price", e.target.value)
    //         // }
    //         type="number"
    //         variant="outlined"
    //         size="small"
    //         sx={{
    //           // "& .MuiInputBase-input": {
    //           //   fontSize: "12px", // Smaller font
    //           //   height: "55px", // Reduce height
    //           // },
    //           "& .MuiOutlinedInput-root": {
    //             height: "30px", // Overall height of TextField
    //             marginTop: "10px",
    //             width: "90%",
    //           },
    //           "@media (max-width: 600px)": {
    //             "& .MuiOutlinedInput-root": {
    //               height: "30px", // Smaller height on small screens
    //               width: "80%",
    //             },
    //           },
    //         }}
    //       />
    //     </Box>
    //   ),

    // },
  
  ];



  console.log("did", priceListdata)

  return (
    <div className='row' style={{ height: "100%" }}>
      <div className='col-sm-12 col-md-9'>
        <div style={{ height: "100%" }}>
          <div className=" d-flex flex-warp justify-content-between align-items-center p-2">
            <h3 className='distributerfont'>Price List</h3>
            <div>
              <div className='d-flex align-items-center' >
                <TextField
                  id="standard-basic"
                  placeholder="Search"
                  variant="standard"
                  className='me-2'
                  sx={{
                    width: "8rem", // Set width
                    // "& input": {
                    //   fontSize: "14px", // Text inside the input field
                    // },
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "12px", // Reduce placeholder size

                    },
                  }}

                />
                <div className='search_icon'>
                  <SearchIcon fontSize='7px' />

                </div>
                <PersonIcon className='ms-2' />
                <div>

                </div>
              </div>
            </div>


          </div>
          <div className='d-flex justify-content-end'>
            {/* <button
              type="button"
              className="rounded submitbutton m-1"
              onClick={handleInvestmentOpen}
            >
              Add Investment
            </button> */}
            {/* <button
              type="button"
              className="rounded submitbutton m-1 "
              onClick={() => {
                setShowForm(!showForm); // Toggle form visibility
              }}

            >
              {showForm ? "Price List" : "Create Price List"}
            </button> */}
            {/* Investment Modal */}
            {/* <Dialog open={investmentModal} onClose={handleInvestmentClose} fullWidth maxWidth="sm">
              <DialogTitle>Enter Investment Amount</DialogTitle>
              <DialogContent>
                <TextField
                  label="Investment Amount"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={investmentAmount}
                  onChange={(e) => setInvestmentAmount(e.target.value)}
                  margin="normal"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleInvestmentClose} color="secondary">
                  Cancel
                </Button>
                <Button onClick={handleInvestmentSubmit} color="primary" variant="contained">
                  Submit
                </Button>
              </DialogActions>
            </Dialog> */}
          </div>

      
              <div>
                <ThemeProvider theme={theme}>
                  <div style={{ height: 400, width: "100%" }}>

                    <DataGrid
                      rowSpacingType='border'

                      rows={rowdata}
                      columns={columns}
                      // rowsPerPageOptions={[5]}
                      checkboxSelection  // Enable checkbox selection
                      disableRowSelectionOnClick
                      // onRowSelectionModelChange={(newRowSelectionModel) => {
                      //   setRowSelectionModel(newRowSelectionModel);
                      // }}
                      // rowSelectionModel={rowSelectionModel}
                      pagination={false}
                      hideFooter
                      sx={{
                        border: 'none', // Change outer border color
                        fontFamily: "Calibri, sans-serif",
                        "& .MuiCheckbox-root": {
                          padding: "4px",  // Reduce padding
                          transform: "scale(0.7)",  // Scale down checkbox size
                        },
                        "& .MuiDataGrid-row": {
                          border: "1px solid #dee2e6 !important",  // Remove row border
                          marginTop: "0.2rem",

                        },
                        "& .MuiDataGrid-cell": {
                          border: "none !important",  // Remove cell borders
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          border: "none !important", // Remove header row bottom border

                        },
                        "& .MuiDataGrid-filler": {
                          rowBorderColor: "none"
                        },
                        "& .MuiDataGrid-root": {
                          border: "none !important", // Removes outer border
                        },

                      }}

                    />
                  </div>
                  {/* <div className='d-flex justify-content-end'>
                    <button className='submitbutton mt-2' onClick={handleSubmit}>
                      Submit
                    </button>
                  </div> */}
                </ThemeProvider>
              </div>
          
        </div>
      </div>
      <div className='col-sm-12 col-md-3 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
        <div className="bg-white my-4 mx-2 p-3 rounded-5">
          <h5>Details</h5>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.
          </p>
        </div>

      </div>


    </div>
  )
}

export default PriceList